export default __webpack_public_path__ + "static/media/opinion-1.f5381808.svg";